var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.203,
    height: 30.96,
    viewBox: "0 0 26.203 30.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shower_1_",
    "data-name": "shower(1)",
    d: "M6.047,0h6.974a6.054,6.054,0,0,1,6.047,6.047V9.6A8.357,8.357,0,0,1,26.2,17.859a1.209,1.209,0,0,1-1.209,1.209H10.723a1.209,1.209,0,0,1-1.209-1.209A8.357,8.357,0,0,1,16.649,9.6V6.047a3.632,3.632,0,0,0-3.628-3.628H6.047A3.632,3.632,0,0,0,2.419,6.047v23.7a1.209,1.209,0,1,1-2.419,0V6.047A6.053,6.053,0,0,1,6.047,0Zm6.01,16.649h11.6a5.927,5.927,0,0,0-11.6,0Zm4.593,5.372v1.814a1.209,1.209,0,1,0,2.419,0V22.021a1.209,1.209,0,1,0-2.419,0Zm.014,5.916v1.814a1.209,1.209,0,1,0,2.419,0V27.937a1.209,1.209,0,1,0-2.419,0ZM21.4,22.021v1.814a1.209,1.209,0,1,0,2.419,0V22.021a1.209,1.209,0,1,0-2.419,0Zm.014,5.916v1.814a1.209,1.209,0,1,0,2.419,0V27.937a1.209,1.209,0,1,0-2.419,0Zm-9.5-5.916v1.814a1.209,1.209,0,1,0,2.419,0V22.021a1.209,1.209,0,1,0-2.419,0Zm.014,5.916v1.814a1.209,1.209,0,1,0,2.419,0V27.937a1.209,1.209,0,1,0-2.419,0Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.02d4e1e5c30eb05241087f09c3c36a51.svg";
export { ForwardRef as ReactComponent };